type GatePayload = { unlocked?: boolean; error?: string };

const messages: Record<string, string> = {
  INVALID_CODE: 'That website access code is not correct.',
  RATE_LIMITED: 'Too many attempts. Wait ten minutes before trying again.',
  NOT_CONFIGURED: 'The website access code has not been configured yet.',
  FORBIDDEN: 'The website access request was rejected.',
  BACKEND_UNAVAILABLE: 'The website gate could not be reached. Check your connection and retry.',
};

export class SiteAccessError extends Error {
  constructor(public code: string) { super(messages[code] ?? messages.BACKEND_UNAVAILABLE); }
}

async function read(result: Response) {
  const payload = await result.json().catch(() => ({ error: 'BACKEND_UNAVAILABLE' })) as GatePayload;
  if (!result.ok || payload.error) throw new SiteAccessError(payload.error ?? 'BACKEND_UNAVAILABLE');
  return payload.unlocked === true;
}

export async function siteAccessStatus() {
  try { return await read(await fetch('/api/site-access', { credentials: 'same-origin', cache: 'no-store' })); }
  catch (problem) {
    if (problem instanceof SiteAccessError) throw problem;
    throw new SiteAccessError('BACKEND_UNAVAILABLE');
  }
}

export async function unlockSite(code: string) {
  try {
    return await read(await fetch('/api/site-access', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({ code }),
    }));
  } catch (problem) {
    if (problem instanceof SiteAccessError) throw problem;
    throw new SiteAccessError('BACKEND_UNAVAILABLE');
  }
}
